import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';
const MODULE_PREFIX = '[ MOST_BOUGHT ]';

const Actions = {
	fetchMostBoughtStocks: `${MODULE_PREFIX} fetchMostBoughtStocks`,
	setMostBoughtStocks: `${MODULE_PREFIX} setMostBoughtStocks`,
	setMostBoughtPullRefreshState: `${MODULE_PREFIX} setMostBoughtPullRefreshState`,
};

// actions
export const fetchMostBoughtStocks = createAction(
	Actions.fetchMostBoughtStocks,
);
export const setMostBoughtStocks = createAction(Actions.setMostBoughtStocks);
export const setMostBoughtPullRefreshState = createAction(
	Actions.setMostBoughtPullRefreshState,
);

// Selectors
export const getMostBoughtStocks = (state) => {
	const data = get(state, 'mostBoughtStock.mostBoughtStocks', []);
	return data;
};

// initialState
const initialState = {
	mostBoughtStocks: [],
	mostBoughtPullRefreshState: {},
};

// reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setMostBoughtStocks, (state, action) => {
		state.mostBoughtStocks = action.payload;
	});
	builder.addCase(setMostBoughtPullRefreshState, (state, action) => {
		state.mostBoughtPullRefreshState = action.payload;
	});
});
